import { render, staticRenderFns } from "./DepTree.vue?vue&type=template&id=4ed3897c&scoped=true&"
import script from "./DepTree.vue?vue&type=script&lang=js&"
export * from "./DepTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed3897c",
  null
  
)

export default component.exports